import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

interface Props {
  label?: string;
  value: string | number;
  icon?: string;
  placeholder?: string;
  type?: string;
  readonly?: boolean;
  disabled?: boolean;
  error?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiInput',
  props: {
    label: null,
    value: null,
    icon: null,
    placeholder: null,
    type: null,
    readonly: { type: Boolean },
    disabled: { type: Boolean },
    error: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: string | number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  label?: string;
  value: string | number;
  icon?: string;
  placeholder?: string;
  type?: string;
  readonly?: boolean;
  disabled?: boolean;
  error?: string;
};




const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const input = ref();

return { __sfc: true,props, emit, valueLocal, input }
}

})